import styled, { css } from "styled-components";

const labelStyles = css`
  ${(props) => props.labelStyles}
`;

export const GenrealInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${(props) => props.marginTop ?? "10px;"};
  padding-bottom: 10px;
`;

export const Title = styled.h2`
  color: #00aeea;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  padding-top: 10px
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  padding-left: 10px;
  justify-self: auto;
`;

export const ButtonWrapper = styled.div`
  text-align: right;
  margin-right: 10px;
  margin-top: 5px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gridGap ?? "1.25rem"};
  font-weight: normal;
  margin-bottom:  ${(props) => props.marginBottom ?? "10px"};
}
`;

export const PaddingDiv = styled.div`
  padding: 15px;
`;

export const NoContact = styled.span`
  font-family: Lato;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: left;
  color: ${(props) => (props?.color ? props.color : "#cccccc;")};
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  margin: 20px;
`;

export const ListTitle = styled.li`
  color: #0a4986;
  font-weight: 700;
`;

export const ListSubTitle = styled.li`
  color: #474747;
  font-weight: 700;
  margin-left: 20px;
`;
export const ListContent = styled.li`
  color: #474747;
  font-weight: 400;
  margin-left: 20px;
  list-style: none;
`;

export const ContentAsTitle = styled.li`
  color: #474747;
  font-weight: 400;
  list-style: none;
`;

export const FlexHeader = styled.div`
  background-color: #008395;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  display: flex;
  font-size: 16px;
  font-weight: 700;
  border-radius: 5px 5px 0px 0px;
`;

export const ContainerLabel = styled.label`
  width: auto;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 1;
  color: ${(props) => props.color ?? "#1bace4"};
  text-align: center;
  text-align: left;
  margin-top: 10px;
  ${labelStyles}
`;
